/** Primetime Emmy TV shelves — one consolidated rail per category, newest year
 *  first, winner first within each year, then nominees by Curator score.
 *  Same structure as the Golden Globe rails. */

import EMMY_TV_NOMINATIONS from "./data/emmyTvNominations.js";
import { orderAwardCategoryItems } from "./appleTvAwardShelf";

export const EMMY_TV_YEARS = [2026];

export const EMMY_TV_CATEGORIES = [
  { key: "drama", label: "Outstanding Drama Series" },
  { key: "comedy", label: "Outstanding Comedy Series" },
  { key: "limited", label: "Outstanding Limited Series" },
  { key: "reality", label: "Reality Competition" },
  { key: "animated", label: "Outstanding Animated Series" },
  { key: "variety", label: "Variety Series" },
];

const EMMY_CATEGORY_KEY_RE = /^tv-emmy-(drama|comedy|limited|reality|animated|variety)$/;

export function isEmmyCategoryShelfKey(key) {
  return EMMY_CATEGORY_KEY_RE.test(String(key || ""));
}

export function parseEmmyCategoryShelfKey(key) {
  const match = String(key || "").match(EMMY_CATEGORY_KEY_RE);
  if (!match) return null;
  return { category: match[1] };
}

export function getEmmyNominationEntries(year, category) {
  const entries = EMMY_TV_NOMINATIONS?.[String(year)]?.[category];
  return Array.isArray(entries) ? entries : [];
}

/** Every unique TMDB id nominated in a category across all years (for the discover request). */
export function getEmmyCategoryTmdbIds(category, years = EMMY_TV_YEARS) {
  const ids = new Set();
  for (const year of years) {
    for (const entry of getEmmyNominationEntries(year, category)) {
      const id = Number(entry?.id);
      if (Number.isFinite(id) && id > 0) ids.add(id);
    }
  }
  return [...ids];
}

export function orderEmmyCategoryItems(category, cardItems, years = EMMY_TV_YEARS) {
  return orderAwardCategoryItems({
    nominations: EMMY_TV_NOMINATIONS,
    category,
    cardItems,
    years,
    keyPrefix: "tv-emmy",
  });
}
